<section *ngIf="menu$ | async as menu">
    <div>
        <ng-container *ngFor="let menuItem of menu">
            <nav-item [item]="menuItem" [class.disabled]="menuItem.disabled" (outEvent)="eventHandler($event)"> </nav-item>
        </ng-container>
    </div>
</section>
